import React from 'react';
import './BotStatus.css';

function BotStatusBadge({ onlineCount, totalCount, onClick }) {
  const hasBots = totalCount > 0;
  const allOnline = onlineCount === totalCount && hasBots;
  const someOnline = onlineCount > 0 && !allOnline;

  let dotClass = 'bot-status-dot';
  if (allOnline) dotClass += ' bg-success';
  else if (someOnline) dotClass += ' bg-warning';
  else if (hasBots) dotClass += ' bg-danger';

  return (
    <span className="bot-status-badge" title="Satellite Bot Status" onClick={onClick} style={{ cursor: 'pointer' }}>
      <span className={dotClass} />
      <span className="bot-badge-count">{onlineCount}/{totalCount}</span>
    </span>
  );
}

export default BotStatusBadge;
